<template>
  <div class="loading-overlay">
    <div class="center">
      <div class="icon"></div>
      <div class="label">
        <slot>Loading</slot>
      </div>
      <div class="disclaimer">
        <slot name="disclaimer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="stylus">
.loading-overlay
  background: rgba(255, 255, 255, 0.3)
  height: 100%
  left: 0
  position: absolute
  top: 0
  width: 100%

  .center
    align-items: center
    display: flex
    flex-direction: column
    left: 50%
    position: absolute
    top: 50%
    transform: translate(-50%, -50%)

    .icon
      animation: sk-scaleout 1s infinite ease-in-out
      background-color: #333
      border-radius: 100%
      height: 40px
      width: 40px

    .label
      m-font-size(14, 18)
      font-family: $base-font-family
      margin-top 5px
      text-align: center
    .disclaimer
      m-font-size(12, 16)
      font-family: $base-font-family
      margin-top 10px
      text-align: center
      color $storm-gray

  @keyframes sk-scaleout
    0%
      transform: scale(0)

    100%
      opacity: 0
      transform: scale(1)
</style>